import Controller from "./customers.controller";
import template from "./customers.html";

const customersPage = {
  template,
  controller: Controller,
};

export default customersPage;



// WEBPACK FOOTER //
// ./src/pages/customers/customers.component.js